/**
 * from https://levelup.gitconnected.com/javascript-wait-until-something-happens-or-timeout-82636839ea93
 *  */
async function sleepUntil(f, timeoutMs = 5000, retryInterval = 100) {
  return new Promise((resolve, reject) => {
    let timeWas = new Date();
    let wait = setInterval(function () {
      if (f()) {
        //console.log("resolved after", new Date() - timeWas, "ms");
        clearInterval(wait);
        resolve();
      } else if (new Date() - timeWas > timeoutMs) {
        // Timeout
        //console.warn("rejected after", new Date() - timeWas, "ms");
        clearInterval(wait);
        reject();
      }
    }, retryInterval);
  });
}

export default sleepUntil;
